import { createUppyPlugin } from '@support/core';

export const UppyPlugin = createUppyPlugin({
  endpoint: import.meta.env.VITE_SUPPORT_API_URL,
  cookiesRule: 'include',
});
